<template>
    <div id="app" v-if="route_name && route_name !== 'alipayRedirect'">
        <ct-container>
            <ct-header :height="76" class="fixed-header">
                <v-header></v-header>
                <div class="nav-progress"></div>
            </ct-header>
            <ct-main class="content" :class="{'user-page': route_name === 'login' || route_name === 'register'}">
                <transition name="flash">
                    <keep-alive include="LiveCourses">
                        <!-- 如果是直播列表页，会缓存滚动数据 -->
                        <router-view v-show="vis"></router-view>
                    </keep-alive>
                </transition>
            </ct-main>
            <!-- <ct-footer style="min-height: 100px;z-index: 10;">
        <v-footer></v-footer>
      </ct-footer> -->
        </ct-container>
        <!-- <div class="mycourses-btn" :class="courseModal ? 'no-hover' : ''">
      <div v-show="courseModal" class="mycourses-tip-box">
        <p>
          {{ courseModalText }}
        </p>
      </div>
      <ct-button
      :circle="true"
      type="primary"
      @click="goMyCourses">
      <ct-icon style="font-size: 18px;line-height: 14px;" name="wodekecheng1"></ct-icon>
      <span class="courses-text">My courses</span></ct-button>
    </div> -->
        <ct-modal v-if="courseModal" title="" @clickFake="clickCourseModal" @closed="courseModal = false"
            class="myCourseModal">
        </ct-modal>
        <ct-button :circle="true" class="feedback-btn" type="secondary" @click="clickFeedback">
            <ct-icon style="font-size: 18px;line-height: 14px;" name="sy-icon-feedback"></ct-icon>
            <span class="feedback-text">{{ $t('nav.Feedback')}}</span></ct-button>
        <ct-button :circle="true" class="back-top-btn" type="secondary" @click="backTop">
            <ct-icon style="font-size: 18px;line-height: 14px;" name="sy-icon-back"></ct-icon>
            <span class="back-top-text">{{ $t('nav.BackToTop')}}</span></ct-button>
        <ct-modal @closed="cancelFeedback" v-if="feedbackModal" class="feedbackModal" :title="$t('nav.FeedbackTitle')"
            :width="isMobile ? '90%' : '560px'">
            <div slot="body">
                <h3 class="feedback-title">{{ $t('nav.Feedback')}} *</h3>
                <textarea name="" id="feecback-ta" maxlength="500" :placeholder="$t('nav.FeedbackPlaceholder')"
                    v-model.trim="textareaTxt">
        </textarea>
                <div class="input-hint"><span>{{hasInput}}</span> / 500</div>
            </div>
            <div slot="footer">
                <ct-button @click="cancelFeedback" type="text_secondary_light">{{ $t('common.Cancel')}}</ct-button>
                <ct-button @click="sendFeedback" :isLoading="modalLoading" :disabled="feedbackDisable" type="primary">{{
                    $t('common.Submit')}}</ct-button>
            </div>
        </ct-modal>
        <improve-info
            :visible="improveModalVisible"
            :formInfo="improveForm"
            @close="closeImproveInfo"
            @success="closeImproveInfo"></improve-info>
    </div>
    <div id="app" v-else-if="noNeedLayout">
        <router-view></router-view>
    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import Footer from '@ca/views/general/Footer'
import Header from '@ca/views/general/Header'
import api from '@ca/api'
import { vueAppDomin, vueAppPassportDomin } from '@ca/constants/variables'
import { VERSION } from '@ca/constants'
import ImproveInfo from '@/components/improve-info/index'
import cookie from '@/utils/cookie'

export default {
  name: 'app',
  data () {
    return {
      route_name: '',
      feedbackModal: false,
      textareaTxt: '',
      modalLoading: false,
      vis: false,
      appVersion: VERSION,
      courseModal: false,
      courseModalText: 'This course has already in My Courses page! Click here to visit.',
      isMobile: window.innerWidth < 768,
      improveModalVisible: false,
      improveForm: {
        school: '',
        grade: '',
        // 英文名
        nickname: '',
        // 中文名
        username: '',
        signature: ''
      }
    }
  },
  methods: {
    ...mapActions(['changeDomTitle', 'getProfile']),
    backTop () {
      let num = document.documentElement.scrollTop || document.body.scrollTop
      let step = Math.floor(num / 50)
      if (step < 50) step = 50
      let timeId = setInterval(() => {
        if ((num - step) > 0) {
          num -= step
          window.scrollTo(0, num)
        } else {
          window.scrollTo(0, 0)
          clearInterval(timeId)
        }
      }, 1)
    },
    clickCourseModal () {
      this.courseModal = false
    },
    clickFeedback () {
      if (this.feedbackModal) return
      this.feedbackModal = true
    },
    cancelFeedback () {
      this.feedbackModal = false
    },
    goMyCourses () {
      if (this.isAuthenticated) {
        this.$router.push({ name: 'userCourses' })
      } else {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + vueAppDomin + '/user/courses'
      }
    },
    sendFeedback () {
      if (!this.textareaTxt.length) return
      this.modalLoading = true
      api.sendFeedback({
        data: {
          desc: this.textareaTxt,
          device: window.navigator.userAgent,
          app_version: this.appVersion
        }
      }).then(res => {
        const data = res.data
        if (data.code === 1) {
          this.feedbackModal = false
          this.textareaTxt = ''
          this.$toast(this.$t('nav.FeedbackSuccess'), 'success')
        } else {
          this.$toast(this.$t('common.ErrAgain'), 'error')
        }
        this.modalLoading = false
      })
    },
    closeImproveInfo () {
      this.improveModalVisible = false
      const domain = window.location.host.split(':')[0].split('.').splice(1).join('.')
      cookie.setCookie('showImprove', 0, '-1', '.' + domain)
    }
  },
  components: {
    // 'v-footer': Footer,
    'v-header': Header,
    ImproveInfo
  },
  beforeMount () {
    this.getProfile().then(({ code, data }) => {
      const showImprove = cookie.getCookie('showImprove')
      if (code === 1 && +showImprove === 1 && this.$route.name !== 'answer') {
        if (!data.school || !data.grade || !data.username || !data.nickname) {
          this.improveForm = {
            school: data.school,
            grade: data.grade,
            // 英文名
            nickname: data.nickname,
            // 中文名
            username: data.username,
            signature: data.signature
          }
          this.improveModalVisible = true
        }
      }
    })
    this.$on('show-course-modal', () => {
      console.log(123)
    })
  },
  mounted () {
    this.route_name = this.$route.name
    this.vis = true
  },
  watch: {
    '$route' (current) {
      this.vis = false
      this.changeDomTitle()
      this.route_name = current.name
      this.$nextTick(() => {
        this.vis = true
      })
    }
  },
  destroyed () {
    this.courseModal = false
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    hasInput () {
      return this.textareaTxt.length
    },
    feedbackDisable () {
      return this.textareaTxt.length === 0 || this.modalLoading
    },
    noNeedLayout () {
      return this.route_name && (this.route_name === 'alipayRedirect' || this.route_name === 'wxCode')
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nav-progress {
  width:100%;
  height:1px;
  background:rgba(241,246,252,1);
  margin-top: -1px;
}
.ct-container {
  min-height: 100vh;
}
.fixed-header {
  position: fixed;
  top: 0;
    width: 100vw;
  z-index: 1200;
  background: #fff;
}
.content.ct-main {
  min-height: 80vh;
  margin-top: 76px;
  &.user-page {
    display: flex;
  }
  .flash-enter, .flash-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .flash-enter-active, .flash-leave-active {
    transition: all .3s ease-in-out;
  }
}
.ct-layout{
  @media screen and (max-width: 1140px){
    width: 100%;
  }
}
.back-top-btn {
  position: fixed;
  left: 50vw;
  margin-left: 610px;
  bottom: 176px;
  z-index: 11;
  background: transparent;
  .back-top-text {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    font-size:16px;
    color:rgba(26,61,94,1);
    line-height:19px;
    margin-right: 4px;
    line-height: 34px;
    padding: 0 12px;
    background: rgba(55, 202, 215,.8);
    border-radius: 2px;
  }
  &:hover {
    .back-top-text {
      display: block;
    }
  }
}
.feedback-btn {
  position: fixed;
  left: 50vw;
  margin-left: 610px;
  bottom: 232px;
  z-index: 11;
  background: transparent;
  .feedback-text {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    font-size:16px;
    color:rgba(26,61,94,1);
    line-height:19px;
    padding: 0 12px;
    margin-right: 4px;
    line-height: 34px;
    background: rgba(55, 202, 215,.8);
    border-radius: 2px;
  }
  &:hover {
    .feedback-text {
      display: block;
    }
  }
}
.mycourses-btn {
  position: fixed;
  left: 50vw;
  margin-left: 610px;
  bottom: 288px;
  z-index: 11;
  .courses-text {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    font-size:16px;
    color:rgba(26,61,94,1);
    line-height:19px;
    margin-right: 4px;
    line-height: 34px;
    padding: 0 12px;
    background: rgba(55, 202, 215,.8);
    border-radius: 2px;
  }
  &:hover {
    .courses-text {
      display: block;
    }
  }
  &.no-hover {
    z-index: 10000;
    &:hover {
      .courses-text {
        display: none;
      }
    }
  }
  .mycourses-tip-box {
    position: absolute;
    right: 72px;
    top: 50%;
    transform: translateY(-50%);
    padding: 24px;
    width: 257px;
    background: rgba(55, 202, 215, 1);
    box-shadow:0px 2px 14px 0px rgba(27,49,69,0.16);
    &::before {
      content: '';
      display: block;
      background: rgba(55, 202, 215, 1);
      width: 12px;
      height: 12px;
      position: absolute;
      right: -6px;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      transform-origin: center center;
    }
  }
}

.feedbackModal {
  .feedback-title {
    padding: 8px 0;
    margin: 0;
    font-size:14px;
    font-weight:400;
    color:rgba(26,61,94,1);
    line-height:14px;
  }
  #feecback-ta {
    resize: none;
    width: 100%;
    height: 248px;
    padding: 13px 12px;
    border: 1px solid rgba( 26, 61, 94, .3);
    font-size:14px;
    font-weight:400;
    color:#1A3D5E;
    line-height:22px;
    outline: none;
    &::placeholder {
      font-size:14px;
      font-weight:400;
      color:rgba( 26, 61, 94, .3);
      line-height:22px;
    }
    &:focus {
      border: 1px solid rgba( 26, 61, 94, 1);
    }
  }
  .input-hint {
    text-align: right;
    font-size:14px;
    color:#A3B1BF;
    line-height:14px;
    margin-top: 4px;
    span {
      color: #1A3D5E;
    }
  }
}

@media screen and (max-width: 1300px) {
  .back-top-btn,
  .feedback-btn,
  .mycourses-btn {
    left: unset;
    margin-left: unset;
    right: 1vw;
  }
}

</style>
<style>
.myCourseModal .ct-modal--box {
  display: none!important;
}
</style>
